import React, { useEffect, useState } from 'react';

const useProduct = () => {

    const [products, setProducts] = useState([]);


    useEffect(() => {
        fetch(`https://protected-plateau-21838.herokuapp.com/products`)
            .then(Response => Response.json())
            .then(data => {
                setProducts(data);

            })


    }, []);

    return [products, setProducts];
};

export default useProduct;